import React, { useEffect, useImperativeHandle, useState } from "react";
import { Button, Input } from "../Elements";
import Modal from "../Modal";
import HtmlTooltip from "../HtmlTooltilp";
import { Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import { Checkbox } from "../Elements";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";

type ComponentProp = {
    updateCallBack: Function
}

const SetInstallmentDetailModal = React.forwardRef((props: ComponentProp, ref) => {
    const firmInformations = useRecoilValue(tenantState);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [fields, setFields] = useState({
        installment: 0,
        valorDate: "",
        commissionAmount: "",
        status: false,
        serviceCommissionRate: "",
        extraInstallmentCount: "",
        extraInstallmentLowLimit: "",
        extraInstallmentUpLimit: "",
        deferralCount: "",
        deferralLowLimit: "",
        deferralUpLimit: "",
        termUpLimit: "",
        lowerLimit: "",
        upperLimit: "",
        isBusiness: true,
        isIndividual: true,
        paymentSpecCode: "",
        paymentPlanCode: ""
    });

    const [createLoading, setCreateLoading] = useState(false);

    useImperativeHandle(ref, () => ({
        openModal(defaultValues: any) {
            if (defaultValues.isIndividual || defaultValues.isBusiness) {
                setFields(defaultValues);

            } else {
                setFields({
                    ...defaultValues,
                    isBusiness: true,
                    isIndividual: true,

                })
            }
            setIsModalVisible(true);
            setCreateLoading(false);
        }

    }));

    useEffect(() => {

        props.updateCallBack(fields);
    }, [fields]);

    const onUpdateClick = async () => {
        setIsModalVisible(false);
        // props.updateCallBack(fields);

    }

    const onChangeField = (event: any, type: any) => {
        var vvv = "";

        var val = event.target.value;
        if (event.target.type == "checkbox") {
            val = event.target.checked;
        } else {
            val = val.replaceAll(",", "");
        }
        if (type == "number") {
            val = parseInt(val);
        }
        setFields({
            ...fields,
            [event.target.name]: val
        });
    }

    const closeModalValidation = () => {
        var errors = [];
        var message = "";


        closeModal();
    }

    const closeModal = () => {
        setErrorMessages([]);
        setIsModalVisible(false);

    };

    const FieldTooltip = ( title: any, content: any ) => (
        <HtmlTooltip
            title={
                <React.Fragment>
                    <Typography color="inherit">{title}</Typography>
                    {content}

                </React.Fragment>
            }
        >
            <InfoOutlined className='text-gray-text ml-2 text-contrast-50' fontSize="small" style={{

            }} />
        </HtmlTooltip>
    )

    const inputTextSizeLimitter = (max: any, min: any) => {
        return {
            isAllowed: (values: any) => {
                const { floatValue } = values;
                return floatValue === undefined || floatValue >= (min || 0) && floatValue <= (max || 99);
            }
        }
    }

    const dbDecimalMaxLimit = 999999999999.999999

    const isOnstallment_1 = fields.installment == 1;

    return (
        <Modal openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} dialogclassName={"modal-w-42 !mt-20"} >
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:text-left w-[100%]">
                        <h3 className="text-md leading-6 font-medium text-primary mb-2 ">
                            Taksit Düzenle {`(${isOnstallment_1 ? "Peşin" : fields.installment + " Taksit"})`}

                        </h3>
                        <div className="w-100 ">

                            <div className=" mb-4 p-3 bg-white ">
                                <div className="flex flex-row justify-between items-center  pb-2 mb-2  border-b-2">
                                    <h3 className="font-bold text-contrast-90">
                                        Genel Ayarlar
                                    </h3>
                                </div>
                                <div className="flex-auto w-50 grid grid-cols-3 gap-4">
                                    <div className="">
                                        <Input
                                            name={`commissionAmount`}
                                            value={fields.commissionAmount}
                                            type="text"
                                            className="w-[100%]"
                                            label="Komisyon Oranı"
                                            placeholder="0.00"
                                            onChange={onChangeField}
                                            // mask="99.99"
                                            {...inputTextSizeLimitter()}
                                            currencyformat="true"
                                            isFourDigits={true}
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Müşteriye yansıtılacak komisyon oranını giriniz"} />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5 mt-4 sm: sm:flex sm:justify-end space-x-2">
                    <Button
                        color="gray"
                        hover="gray"
                        size="xs"
                        callback={() => closeModalValidation()}
                    >
                        Kapat
                    </Button>
                </div>
            </div>
        </Modal>
    );
})

export default SetInstallmentDetailModal;